import Vue from 'vue';
import elementUi from 'element-ui';
import VueHotkey from 'v-hotkey';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import { Amplify } from 'aws-amplify'
import { generateClient } from 'aws-amplify/api';
import VueFilterDateFormat from 'vue-filter-date-format';
import Vuebar from 'vuebar';
// import VBar from 'v-bar';
import Affix from 'vue-affix';
import checkView from 'vue-check-view';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Sortable from 'vue-sortable';
import draggable from 'vuedraggable';
import VueMobileDetection from "vue-mobile-detection";
// import { Datetime } from 'vue-datetime';
import {
  DatetimePicker, Popup, Picker, Locale as localeVant,
} from 'vant';

import enUS from 'vant/lib/locale/lang/en-US';
import App from './App.vue';
import router from './router';
import store from './store';
import './filters';
import awsExports from './aws-exports';
import './components';
import './index.css';
import './assets/icons-new/style.css';
import { registerMaIcons } from './icons/registerMaIcons';

library.add(faExchangeAlt);
dom.watch();
Vue.component('font-awesome-icon', FontAwesomeIcon);

locale.use(lang);
localeVant.use('en-US', enUS);
Vue.config.productionTip = false;

Vue.use(elementUi);
Vue.use(Affix);
Vue.use(checkView);
Vue.use(VueHotkey);
Vue.use(Sortable);
Vue.use(draggable);
Vue.use(VueFilterDateFormat);
Vue.use(Vuebar);
// Vue.use(VBar);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(VueMobileDetection);
// Vue.component('datetime', Datetime);
console.log('process.env', process.env);
const config = awsExports[process.env.VUE_APP_MODE];

// Override default S3 bucket to use the upload bucket (console-uploads)
// This ensures uploadData calls target the correct bucket
if (config.aws_upload_bucket) {
  config.aws_user_files_s3_bucket = config.aws_upload_bucket;
  // Assume upload bucket is in the project region (eu-west-1) rather than the default ap-southeast-1
  config.aws_user_files_s3_bucket_region = config.aws_project_region || 'eu-west-1';
}

Amplify.configure(config);
store.state.awsExports = config;
console.log('=>', process.env, config);

Vue.prototype.$Amplify = Amplify
Vue.prototype.$graphqlClient = generateClient()
registerMaIcons();
const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

store.$app = app;
